import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '@done/ngx-essentials';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LOGIN_ROUTE } from './login-route.constant';
import { PermissionService } from '../features/users-roles/services/permission.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private readonly _accountService: AccountService,
    private readonly _permissionService: PermissionService,
    private readonly _router: Router,
    private http: HttpClient
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn: boolean = this._accountService.isLoggedIn();
    const loginRoute = `/${LOGIN_ROUTE}`;

    let canAccessRoute = false;

    // AT-1224: sem isso, sessão morta fazia o canActivate só devolver false e o Angular
    // Router cancelar a navegação em silêncio (sem redirecionar pro login local) — mesmo
    // padrão já corrigido no auth-guard.service.ts do Docs/Reports. Guarda a rota atual
    // como returnUrl pra tela de login local poder propagá-la depois de relogar.
    // Usa hasSession (existe sessão), não isLoggedIn (validade estrita do access token):
    // token expirado localmente não significa sessão morta — o refresh token pode estar
    // vivo, e a request de permissão renova silenciosamente via HttpInterceptorMiddleware
    // no primeiro 401 real — achado ao vivo na validação manual.
    const hasSession: boolean = !!this._accountService.getUserId();

    if (!hasSession && state.url !== loginRoute) {
      this._router.navigate([loginRoute], { queryParams: { returnUrl: state.url } });
    }

    if (state.url !== loginRoute && hasSession)
      canAccessRoute = await this._permissionService.canAccessRoute(route.data["role"]);

    if (!isLoggedIn)
      await this._accountService.me();

    return canAccessRoute;
  }

  canAccess(accountId: number): Observable<boolean> {
    let userId = this._accountService.getUserId();
    let softwareId_Pointer = 2;

    let params: HttpParams = new HttpParams()
      .append('softwareId', softwareId_Pointer)
      .append('accountId', accountId)
      .append('userId', userId);

    return this.http.get<boolean>(`${environment.apiGateway}/workspace/core/softwareAccesses/canAccess`, { params });
  }
}